import type { KnowledgeItem } from '../../api/knowledgeConsolidation'
import Modal from '../../components/Modal'
import { SourcesTab } from './SourcesTab'

export function ItemDetail({ item, onClose }: { item: KnowledgeItem | null; onClose: () => void }) {
  return (
    <Modal
      isOpen={Boolean(item)}
      onClose={onClose}
      title={item?.title ?? 'Knowledge item'}
      size="lg"
    >
      {item && (
        <div className="space-y-5 text-sm text-harbor-text-secondary">
          <div className="flex gap-2 text-xs uppercase">
            <span>{item.kind}</span>
            <span>{item.confidence} confidence</span>
          </div>
          {item.statement && <p>{item.statement}</p>}
          {item.rationale && (
            <section>
              <h3 className="mb-1 font-semibold text-harbor-text">Rationale</h3>
              <p>{item.rationale}</p>
            </section>
          )}
          <section>
            <h3 className="mb-2 font-semibold text-harbor-text">Sources</h3>
            <SourcesTab evidenceIds={item.evidenceIds} />
          </section>
        </div>
      )}
    </Modal>
  )
}
